@if (isLoadingRepInfo) {
<span class="ghost-line block w-full"></span>
} @else { @if (repInfo) {
<cui-popover #pop align="bottomLeft">
  <button class="cui-popover-link" cui-popover-trigger>
    @if (cardLabel) {
    <span class="font-bold text-gray-900 mr-bl-1">{{ cardLabel }} </span>
    }
    <span
      class="rep-name rep-link"
      [ngClass]="breakWord ? 'break-word' : 'do-not-break-word'"
      >{{
        showLongName
          ? repInfo.name ?? repInfo.shortName
          : repInfo.shortName ?? repInfo.name
      }}{{ showRepId ? tpxIdInParentheses : "" }}</span
    >
  </button>
  <cla-claim-rep-contact-card-redacted
    [rep]="repInfo"
    cui-popover-content
  ></cla-claim-rep-contact-card-redacted>
</cui-popover>
} @else {
{{ tpxId }}
} }
